export class UpdateContactDto {
  street: string;
  number: number;
  suffix: string;
  postalCode: number;
  city: string;
  email: string;
  personId: string;
  language: string;
  name: string;
  personType: string;
  phone: string;

  constructor(
    street?: string,
    number?: number,
    suffix?: string,
    postalCode?: number,
    city?: string,
    email?: string,
    personId?: string,
    language?: string,
    name?: string,
    personType?: string,
    phone?: string
  ) {
    this.street = street;
    this.number = number;
    this.suffix = suffix;
    this.postalCode = postalCode;
    this.city = city;
    this.email = email;
    this.personId = personId;
    this.language = language;
    this.name = name;
    this.personType = personType;
    this.phone = phone;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
